module.exports = __webpack_public_path__ + "img/twitter.90cbda5c.svg";